<template>
  <div class="card__spec" :class="specId">
    <div class="spec__title" :class="selectedSpecialCard ? 'spec__title__crispr' : ''" v-show="specId === 'horseUser'">
      <img src="../assets/image/txt_spec_title.png" alt="あなたのユニコーン">
      <span class="spec__crispr" v-if="selectedSpecialCard"><!--CRISPR-CAS--><img src="../assets/image/txt_crispr_cas.png" alt=""></span>
    </div>
    <div class="spec__detail">
      <p class="spec__detail--title">スピード</p>
      <p class="spec__detail--value">{{ specCard.speed }}</p>
    </div>
    <div class="spec__detail">
      <p class="spec__detail--title">スタミナ</p>
      <p class="spec__detail--value">{{ specCard.stamina }}</p>
    </div>
    <div class="spec__detail">
      <p class="spec__detail--title">コンジョウ</p>
      <p class="spec__detail--value">{{ specCard.brave }}</p>
    </div>
    <div class="spec__detail">
      <p class="spec__detail--title">オチツキ</p>
      <p class="spec__detail--value">{{ specCard.calm }}</p>
    </div>
    <div class="spec__detail">
      <p class="spec__detail--title">ケンコウ</p>
      <p class="spec__detail--value">{{ specCard.health }}</p>
    </div>
    <div class="spec__detail">
      <p class="spec__detail--title">セイベツ</p>
      <p class="spec__detail--value sex">{{ specCard.sex }}</p>
    </div>
    <div class="spec__title" v-show="currentScreen === 'decisionCard' && specId === 'horsePc'"><!--<span>競争相手のユニコーン</span>-->
      <img src="../assets/image/txt_spec_title2.png" alt="競争相手のユニコーン"></div>
  </div>

</template>
<script>
  import { store } from '../store/store'
  export default {
    name: 'CardSpec',
    props: ['specId', 'specCard', 'cardId'],
    data () {
      return {
        msg: 'This is CardSpec'
      }
    },
    computed: {
      currentScreen () {
        return store.state.currentScreen
      },
      isStop () {
        return store.state.isStopSufferCard
      },
      selectedSpecialCard () {
        return store.state.adnSpecial !== -1 // && this.currentScreen === 'decisionCard'
      }
//      specCard () {
//        if (this.isStop) {
//          console.log('card-spec-stop')
//          return store.state[this.specId]
//        } else {
//          console.log('card-spec-start')
//          return this.horse
//        }
//      }
    }
//    watch: {
//      isStop () {
//        if (this.isStop) {
//          console.log('card-spec-stop')
//          this.horse = store.state[this.specId]
//        }
//      }
//    }
  }
</script>



// WEBPACK FOOTER //
// CardSpec.vue?5631fb10